import React from 'react';
import { Tooltip } from '@monite/ui';

const GlobalTooltip = () => {
  return <Tooltip />;
};

export default GlobalTooltip;
